module.exports={
	"Hash": "1990s-website",
	"Name": "1990s Website",
	"Version": "1.0.0",
	"Description": "Classic 90s web: silver-grey and navy with link-blue, or a black GeoCities night with lime and magenta.",
	"Comprehensive": true,
	"Modes": {
		"Strategy": "system",
		"Default": "light"
	},
	"Tokens": {
		"Color": {
			"Background": {
				"Primary": {
					"Light": "#c0c0c0",
					"Dark": "#000000"
				},
				"Secondary": {
					"Light": "#d4d0c8",
					"Dark": "#0a0a0a"
				},
				"Tertiary": {
					"Light": "#cac6be",
					"Dark": "#101010"
				},
				"Panel": {
					"Light": "#ffffff",
					"Dark": "#080808"
				},
				"Hover": {
					"Light": "#d8d8d8",
					"Dark": "#0e1a0e"
				},
				"Selected": {
					"Light": "#aab7d6",
					"Dark": "#10401f"
				}
			},
			"Text": {
				"Primary": {
					"Light": "#000000",
					"Dark": "#00ff66"
				},
				"Secondary": {
					"Light": "#1a1a1a",
					"Dark": "#33ff99"
				},
				"Muted": {
					"Light": "#444444",
					"Dark": "#13aa55"
				},
				"Placeholder": {
					"Light": "#777777",
					"Dark": "#0a7a3a"
				},
				"OnBrand": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Brand": {
				"Primary": {
					"Light": "#000080",
					"Dark": "#ff36ff"
				},
				"PrimaryHover": {
					"Light": "#0000c0",
					"Dark": "#ff66ff"
				},
				"Accent": {
					"Light": "#0000ee",
					"Dark": "#00ffff"
				}
			},
			"Border": {
				"Light": "#808080",
				"Dark": "#0a5c2a"
			},
			"Status": {
				"Success": {
					"Light": "#008000",
					"Dark": "#00ff66"
				},
				"Warning": {
					"Light": "#a06000",
					"Dark": "#ffff00"
				},
				"Error": {
					"Light": "#cc0000",
					"Dark": "#ff3366"
				},
				"Info": {
					"Light": "#000080",
					"Dark": "#00ffff"
				}
			},
			"Scrollbar": {
				"Track": {
					"Light": "#d4d0c8",
					"Dark": "#0a0a0a"
				},
				"Thumb": {
					"Light": "#808080",
					"Dark": "#0a5c2a"
				},
				"Hover": {
					"Light": "#444444",
					"Dark": "#13aa55"
				}
			},
			"Selection": {
				"Background": {
					"Light": "#000080",
					"Dark": "#00ff66"
				},
				"Text": {
					"Light": "#ffffff",
					"Dark": "#000000"
				}
			},
			"Focus": {
				"Outline": {
					"Light": "#000080",
					"Dark": "#ff36ff"
				}
			},
			"Shadow": {
				"Color": {
					"Light": "rgba(0,0,0,0.12)",
					"Dark": "rgba(0,0,0,0.40)"
				}
			}
		}
	},
	"Brand": {
		"Name": "Plansheet",
		"Tagline": "Everything, drafted."
	}
}
